module.exports = {

    language: {
        name: '中文'
    },

    index: {
        time: '北京时间',
        languages: '语言',
        en: '英文',
        cn: '中文',
        tras: '交易标识(TX)',
        block: '区块高度',
        acco: '发送方',
        acti: '接收方',
        gmt: '交易时间',
        zhuce: '注册eos更新',
        for: '对于开发者',
        re: '资源库',
        eosp: 'EOS公链',
        news: '消息',
        events: '活动',
        about: '关于EOSIO',
        // 
        dev: '开发者门户',
        stack: '堆栈交换',
        cont: '接触',
        faq: '常见问题',
        pri: '隐私政策',
        terms: '使用条款',
        notic: '重要通知',
        feed: '回馈',
        secur: '安全',
        numb: '操作数',
        coll: '每 分 采 集 ',
        jiao: '交 易 记 录 ',
        cotime: '采集时间',
        coll5: '每 5 分 采 集'
    }
}



// WEBPACK FOOTER //
// ./src/assets/lang/zh.js